import { render, staticRenderFns } from "./BlocklistSettings.vue?vue&type=template&id=145f3973&scoped=true&"
import script from "./BlocklistSettings.vue?vue&type=script&lang=js&"
export * from "./BlocklistSettings.vue?vue&type=script&lang=js&"
import style0 from "./BlocklistSettings.vue?vue&type=style&index=0&id=145f3973&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f3973",
  null
  
)

export default component.exports